<template>
    <v-app :right="currentFlow" :style="customCssFormBilling">
        <router-view />
        <v-snackbar
            v-model="snackbar.status"
            timeout="-1"
            class="d-print-none"
            shaped
        >
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn color="pink" text v-bind="attrs" @click="close">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <v-overlay :value="overlay" z-index="203" color="white">
            <v-progress-circular indeterminate size="32" color="purple" />
        </v-overlay>
    </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters({
            catchedErrors: "errors/readErrors",
            overlay: "overlay/processing",
            snackbar: "snackbar/snackbarData",
            currentTheme: "configs/theme",
            currentFlow: "configs/rtl",
            billing: "configs/billing",
            cssPageSize: "configs/printSize",
            volu: "configs/volume",
            printerWidth: "configs/printerWidth",
        }),
        volumeSound() {
            return Number(this.volu) / 10;
        },
        customCssFormBilling() {
            const css = this.billing;
            return {
                "--bill-item": css.billItemFontSize + "px",
                "--bill-item-qty": css.billItemQtyFontSize + "px",
                "--bill-date-trans": css.billDateTimeTransFontSize + "px",
                "--bill-hr-size": css.billHrFontSize + "px",
                "--bill-term-size": css.billTermsFontSize + "px",
                "--bill-width": `${this.printerWidth}`,
            };
        },
    },
    watch: {
        currentTheme() {
            this.$vuetify.theme.dark = this.currentTheme;
        },
        currentFlow() {
            this.$vuetify.rtl = this.currentFlow;
        },

        /*---Gobble Error catcher---*/
        catchedErrors(catchedErrors) {
            const { response } = catchedErrors;
            switch (response.status) {
                case 401:
                case 419:
                    alert("You are logged out ! please login");
                    window.location.reload();
                    break;
                case 403:
                    this.feedback(
                        "403 : You do not have permission to access !"
                    );
                    break;
                case 404:
                    router.replace({ name: "Error404" });
                    break;
                case 408:
                    router.replace({ name: "Error408" });
                    break;
                case 422:
                    this.playSound("/storage/sounds/error.mp3");
                    this.catchValidationErrors(response.data.errors);
                    break;
                default:
            }
        },
        /*---end----*/

        snackbar() {
            if (this.snackbar.status) {
                this.playSound("/storage/sounds/ding.mp3");
            }
            setTimeout(() => {
                this.close();
            }, 5000);
        },
    },
    created() {
        this.$vuetify.rtl = this.currentFlow;

        Event.$on("printSize", () => {
            const style = document.createElement("style");
            style.innerHTML = "@page {size:" + this.cssPageSize + "}";
            document.head.appendChild(style);
        });
        this.$vuetify.theme.dark = this.currentTheme;
        this.$vuetify.theme.rtl = this.currentFlow;
        Event.$on("logout", () => {
            this.out().then(() => {
                this.$router.replace({ name: "Login" });
            });
        });
        Event.$on("exportPdfSale", (invoice) => {
            window
                .axios({
                    method: "GET",
                    responseType: "blob",
                    url: `/export-sale-invoice/${invoice}`,
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        ),
                        link = document.createElement("a");

                    link.href = url;
                    link.setAttribute("download", `exported.pdf`);
                    document.body.appendChild(link);
                    link.click();
                });
        });
    },
    methods: {
        ...mapActions({
            catchValidationErrors: "validation/push",
            close: "snackbar/hide",
            out: "auth/logout",
            feedback: "snackbar/show",
        }),
        playSound(sound) {
            if (sound) {
                var audio = new Audio(sound);
                audio.volume = this.volumeSound ?? 5;
                audio.play();
            }
        },
    },
};
</script>

<style type="text/css">
.table td,
.table th {
    padding: 0.1rem;
    vertical-align: top;
    border-top: 0;
    max-width: auto;
    font-size: var(--bill-item);
}
tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
}

.table {
    width: 100%;
    max-width: 100%;
    background-color: transparent;
}
table {
    border-collapse: collapse;
}

*,
::after,
::before {
    box-sizing: border-box;
}

table {
    display: table;
    border-collapse: separate;
    box-sizing: border-box;
    border-spacing: 0px;
    border-color: block;
}
.invoice_mini {
    margin: auto;
    padding: 1px 5px;
    color: #000;
    width: var(--bill-width);
    font-family: Arial !important;
}
.mini-text {
    font-size: var(--bill-item-qty);
}
.slipTrx {
    width: 98%;
    height: 15px;
}
.md-text {
    font-size: var(--bill-date-trans);
}
hr {
    border-top: var(--bill-hr-size) dotted;
}
.pBy {
    font-size: 7px;
    font-family: revert;
}
.term {
    font-family: Arial !important;
    font-size: var(--bill-term-size);
}

/* override styles when printing */
@media print {
    .theme--dark.v-application {
        background: #121212;
        color: #000;
    }
    .invoice_mini {
        margin: auto;
        padding: 1px 5px;
        color: #000;
        font-family: Arial !important;
    }
}
</style>
